import { React, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, InputGroup, OverlayTrigger, Tooltip,  Modal} from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import ServicesRequest from '../../../service/ServiceRequest'
import ReactLoading from "react-loading";
import Swal from 'sweetalert2'
import { ProductString } from '../../../constants/Product-Strings'
import { PublicStrings } from '../../../constants/Public-Strings'
import { AgentString } from '../../../constants/Agent-String'
import { successToast, warningToast } from '../../../constants/Toasts-Components'





const EnabledUsersOrAgenciesList = ({ enabled_for, product_id, setEnabledFor, all_products, item_type}) => {

    const { config } = useSelector((state) => state.auth);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [subordinates, setSubordinates] = useState([]);
    let serviceRequestObj = new ServicesRequest("product");


    // useEffect(() => {

    //     setSubordinates(config.subordinates);

    // }, [enabled_for, subordinates])

    return (
        <>        
            <Card>
                <Card.Body>

                    <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                        
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="font-weight-bold">Abilitato per</h5>
                        </div>

                        <Button variant="primary" onClick={handleShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Aggiungi
                        </Button>
                
                        <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Seleziona il {item_type === "product" ? "prodotto" : item_type === "campaign" ? "campagna" : ""} da abilitare</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        
                                {
                                        <>
                                            {
                                               enabled_for.length === all_products.length ? 
                                    
                                               <i> Tutti i { item_type === "product" ? "prodotti" : item_type === "campaign" ? "campagne" : ""} sono già abilitati </i>
                                                : 
                                            <table className="table data-table mb-0">
                                                                        <tbody>
                                                {all_products.map((item, index) => ( 
                                                    
                                                    enabled_for.map(user  => user.id).includes(item.id) ? <></> :
                                                        <tr className="white-space-no-wrap" key={index+ item.id}>

                                                            <td style={{"padding" : "0px" , "borderTop" : "1px"}}>
                                                                <div className="d-flex justify-content-end align-items-center">

                                                                        <button type="button" className="dropdown-item bg-light border rounded btn-block mb-2" onClick={async () => {
                                                                            
                                                                            const response = await serviceRequestObj.toggleEnableProductForUserOrAgency( item.id,product_id, 'agent', true, item_type)
                                                                            if(response !== null){
                                                                                if(response.response){

                                                                                    Swal.fire({
                                                                                        icon: 'error',
                                                                                        title: 'Error',
                                                                                        text: response.response.data.error_message,
                                                                                    })
                                                                                } else{
                                                                                    console.log("Adding stuff");
                                                                                    handleClose();
                                                                                    console.log(enabled_for);
                                                                                    setEnabledFor(values => ([ ...values, item ]))
                                                                                }  
                                                                            }

                                                                        }}>
                                                                            

                                                                            {item.name}
                                                                        </button>
                                 

                                                                </div>
                                                            </td>
                                                         </tr>
                                                    

                                                ))}
                                            </tbody>
                        </table>
                                            }
                                        </>
                                }
                           

                        </Modal.Body>
                        
                        </Modal>

                    </div>

                    
                    
                                
                                <>
                                {
                                    enabled_for.length === 0 ? 

                                        <i> Questo prodotto non è abilitato per nessun utente </i>
                                    :<table className="table data-table mb-0">
                                    <tbody>
                                          
                                        {enabled_for.map((item, index) => ( 
                                            
                                            <tr id={"enabled_row_"+item.id} key={index+item.id} className="white-space-no-wrap">

                                                <td> {item.name}</td>

                                                <td>
                                                    <div className="d-flex justify-content-end align-items-center">

                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>} >
                                                            <h6 className="badge bg-danger" onClick={async () => {

                                                                const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(item.id,product_id, "agent", false, item_type)
                                                                if(response !== null){
                                                                    if(response.response){

                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: response.response.data.error_message,
                                                                        })
                                                                    } else{
                                                                        console.log("Deleting stuff");
                                                                        setEnabledFor(values => (values.filter(f => f.id !== item.id)));
                                                                        
                                                                    }  
                                                                }

                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </h6>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                        
                                    
                                }
                                </>
                            
                            
                        

                </Card.Body>
            </Card>

        </>
    )
}


const AgentAddOrView = (props) => {

    let serviceRequestObj = new ServicesRequest("user");


    const form = useRef(null);
    const { config } = useSelector((state) => state.auth)

    const [inputs, setInputs] = useState({
        name : '',
        email : '',
        surname : '',
        agency : null,
        is_agent: false,
        is_agency_boss: false,
        is_agency_admin: false,
        is_business_manager: false,
        is_internal_backoffice_manager: false,
        is_internal_backoffice_operator: false,
        is_institute_backoffice_manager: false,
        is_institute_backoffice_operator: false,
        managed_agencies: [],
        password: '',
        confirm_password : '',
        can_force_edit: false,
        min_commission: 0,
        max_commission: 0,
        target: 0,
        services_allowed: true,
        last_activity: '',
        last_login: '',
        is_online: false

    });

    const [enabled_for, setEnabledFor] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [is_renewable, setIsRenewable] = useState(false);
   

    const [is_new_product, setIsNewProduct] = useState(true)
    const [product_id, setProductId] = useState("");

    const params = useParams();

    async function fetchProductInfo(product_id, agencyList = null) {

        setLoading(true);

        const response = await serviceRequestObj.getProductInfo(product_id);
        console.log(response)
        if (!response.response) {

            // setIsRenewable(response['is_renewable']);
            setEnabledFor(response['products_enabled']);
            setAllProducts(response['all_products'])
            if (agencyList) {
                setProductList(agencyList);
            } else {
                setProductList(response['all_agencies'])
            }
            // console.log(response['enabled_for']);

            const columns = ['name', 'email','surname', 'is_agent', 'is_agency_boss','is_agency_admin','is_business_manager','is_internal_backoffice_operator','is_institute_backoffice_operator','is_internal_backoffice_manager','is_institute_backoffice_manager','agency','managed_agencies','can_force_edit','min_commission','max_commission','target','services_allowed', 'last_activity', 'last_login', 'is_online']

            for (const key of columns) {
                var value = response[key];
                if (value !== null) {
                    if(key==='agency' ){

                        setInputs(values => ({ ...values, [key]: value.id }))
                    }else if(key==='managed_agencies'){
                        setInputs(values => ({ ...values, [key]: value.map(e => parseInt(e.id)) }))
                    }else{

                        setInputs(values => ({ ...values, [key]: value }))
                    }
                }
            }
        }
        setLoading(false);
    }


    useEffect(() => {

        console.log("Params:", params);
        setProductId(params.agent_id);
        
        console.log("Params:", params);
        console.log("Agent ID State:", params.agent_id);
        
        const initializeData = async () => {
            const agencyList = await fetchAllAgency();
            if (params.agent_id) {
                setIsNewProduct(false);
                fetchProductInfo(params.agent_id, agencyList);
            } else {
                // Set default role for new products based on user permissions
                if (!config.is_admin) {
                    if (config.is_agency_boss || config.is_agency_admin) {
                        setInputs(values => ({ ...values, is_agent: true }));
                    } else if (config.is_internal_backoffice_manager) {
                        setInputs(values => ({ ...values, is_internal_backoffice_operator: true }));
                    } else if (config.is_institute_backoffice_manager) {
                        setInputs(values => ({ ...values, is_institute_backoffice_operator: true }));
                    }
                }
            }
        };
        
        initializeData();

    }, [])




    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(name,value)
        if(name==='agency' ){
            if(value !== "" && value !== null){
                setInputs(values => ({ ...values, [name]: value }))
            }else{
                setInputs(values => ({ ...values, [name]: value}))
            }
            
        }else{

            setInputs(values => ({ ...values, [name]: value}))
        }

        console.log(inputs)
    }

    const handleMultipleAgencyChange = (event) => {
        const selectedValue = parseInt(event.target.value);
        if (selectedValue && selectedValue !== 0 && !inputs.managed_agencies.includes(selectedValue)) {
            setInputs(values => ({ 
                ...values, 
                managed_agencies: [...values.managed_agencies, selectedValue]
            }))
        }
    }

    const removeAgency = (agencyId) => {
        setInputs(values => ({ 
            ...values, 
            managed_agencies: values.managed_agencies.filter(id => id !== agencyId)
        }))
    }

    const getAgencyNameById = (agencyId) => {
        const agency = productList.find(a => a.id === agencyId || a.id === parseInt(agencyId));
        return agency ? agency.name : '';
    }

    const handleRoleChange = (event) => {
        const selectedRole = event.target.value;
        
        // Reset all role flags
        const newInputs = {
            ...inputs,
            is_agent: false,
            is_agency_boss: false,
            is_agency_admin: false,
            is_business_manager: false,
            is_internal_backoffice_manager: false,
            is_internal_backoffice_operator: false,
            is_institute_backoffice_manager: false,
            is_institute_backoffice_operator: false
        };
        
        // Set the selected role to true
        if (selectedRole !== 'none') {
            newInputs[selectedRole] = true;
        }
        
        // Reset agency fields based on the selected role
        // is_agent and is_agency_boss use single agency field
        // All other roles use managed_agencies
        if (selectedRole === 'is_agency_boss' || selectedRole === 'is_agent') {
            newInputs.managed_agencies = [];
            // Keep agency field - don't set to null
        } else {
            newInputs.agency = null;
            // Keep managed_agencies field - don't reset to empty array
        }
        
        setInputs(newInputs);
    }

    // Get available role options based on current user's permissions
    const getAvailableRoleOptions = () => {
        // Admin can see all options
        if (config.is_admin) {
            return [
                { value: 'none', label: 'Seleziona Ruolo' },
                { value: 'is_agent', label: 'Agente di Agenzia' },
                { value: 'is_agency_boss', label: 'Responsabile di Agenzia' },
                { value: 'is_agency_admin', label: 'Amministratore di Agenzia' },
                { value: 'is_business_manager', label: 'Responsabile Commerciale' },
                { value: 'is_internal_backoffice_manager', label: 'Responsabile Backoffice Interno' },
                { value: 'is_internal_backoffice_operator', label: 'Operatore Backoffice Interno' },
                { value: 'is_institute_backoffice_manager', label: 'Responsabile Backoffice Istituto' },
                { value: 'is_institute_backoffice_operator', label: 'Operatore Backoffice Istituto' }
            ];
        }
        
        // Agency boss and admin can only create Agency Agent
        if (config.is_agency_boss || config.is_agency_admin) {
            return [
                { value: 'is_agent', label: 'Agente di Agenzia' }
            ];
        }
        
        // Internal backoffice manager can only create Internal Backoffice Operator
        if (config.is_internal_backoffice_manager) {
            return [
                { value: 'is_internal_backoffice_operator', label: 'Operatore Backoffice Interno' }
            ];
        }
        
        // Institute backoffice manager can only create Institute Backoffice Operator
        if (config.is_institute_backoffice_manager) {
            return [
                { value: 'is_institute_backoffice_operator', label: 'Operatore Backoffice Istituto' }
            ];
        }
        
        return [{ value: 'none', label: 'Seleziona Ruolo' }];
    }

    // Check if role field should be disabled
    const isRoleFieldDisabled = () => {
        // If not a new product (editing existing), only admin can change
        if (!is_new_product) {
            return !config.is_admin;
        }
        
        // For new products, if user has only one role option, make it readonly
        const availableOptions = getAvailableRoleOptions();
        if (availableOptions.length === 1 && !config.is_admin) {
            return true;
        }
        
        return false;
    }

    // Helper function to get current role
    const getCurrentRole = () => {
        if (inputs.is_agent) return 'is_agent';
        if (inputs.is_agency_boss) return 'is_agency_boss';
        if (inputs.is_agency_admin) return 'is_agency_admin';
        if (inputs.is_business_manager) return 'is_business_manager';
        if (inputs.is_internal_backoffice_manager) return 'is_internal_backoffice_manager';
        if (inputs.is_internal_backoffice_operator) return 'is_internal_backoffice_operator';
        if (inputs.is_institute_backoffice_manager) return 'is_institute_backoffice_manager';
        if (inputs.is_institute_backoffice_operator) return 'is_institute_backoffice_operator';
        return 'none';
    }


    const submitCreateProduct = async (event) => {

        event.preventDefault();
        if(inputs.password.length <8){
            warningToast("Password must be 8 or more")
        }else if(inputs.password !== inputs.confirm_password){
            warningToast("Password not match")
            
        }else{
            setLoading(true);

        // Prepare data to send
        const dataToSend = { ...inputs };
        
        // If is_agency_boss or is_agent, send agency and clear managed_agencies
        if (inputs.is_agency_boss || inputs.is_agent) {
            dataToSend.managed_agencies = [];
        } else {
            // For other roles, send managed_agencies and clear agency
            dataToSend.agency = null;
        }

        const response = await serviceRequestObj.createProduct(dataToSend);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            setProductId(response.id);
            setIsNewProduct(false);
            setInputs(values => ({ ...values, "id": response.id }))
            
                setEnabledFor(response.products_enabled)
                setAllProducts(response.all_products)
            
            const editUrl = "/agent-view/" + response.email;
            window.history.replaceState(null, "", editUrl);
            successToast('Agent Created Successfully..')
        }
        setLoading(false)
        }
        
        
    }


    const submitSaveProduct = async (event) => {
        event.preventDefault();
        setLoading(true);
        console.log(inputs)
        
        // Prepare data to send
        const dataToSend = { ...inputs };
        
        // If is_agency_boss or is_agent, send agency and clear managed_agencies
        if (inputs.is_agency_boss || inputs.is_agent) {
            dataToSend.managed_agencies = [];
        } else {
            // For other roles, send managed_agencies and clear agency
            dataToSend.agency = null;
        }

        console.log("hello")
        console.log(dataToSend)
        
        const response = await serviceRequestObj.saveProduct(dataToSend,inputs['email']);
        console.log(response)
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            successToast('Update Successfully..')
        }
        setLoading(false)
    }
    const [showPasswordModal,setShowPasswordModal] = useState(false);
    function handleClose(){
        setShowPasswordModal(false)
    }
    const [productList, setProductList] = useState([]);
    const [password, setPassword] = useState([]);
    const [confirmPassword, setConfirmPassword] = useState([]);

    async function fetchAllAgency(){
        var RequestService = new ServicesRequest("agency");
        const response = await RequestService.getProductList(null,null,null,null,null,'99999');
        console.log(response)
        if(!response.response){
            console.log(response)
            setProductList(response.data)
            return response.data;
        }
        return [];
    }

    // Get filtered agencies based on selected role
    const getFilteredAgencies = () => {
        console.log("Filtering agencies for role with inputs:", inputs);
        console.log(productList)
        if (inputs.is_agency_admin || inputs.is_business_manager || inputs.is_agent || inputs.is_agency_boss) {
            // Show only agencies where both backoffice flags are false
            return productList.filter(agency => 
                !agency.is_internal_backoffice && !agency.is_institute_backoffice
            );
        }
        return productList;
    }

    // Check if multiple agency selection should be shown
    const isMultipleAgencySelect = () => {
        return inputs.is_agency_admin || inputs.is_business_manager || 
               inputs.is_internal_backoffice_manager || inputs.is_institute_backoffice_manager || 
               inputs.is_internal_backoffice_operator || inputs.is_institute_backoffice_operator;
    }
    async function passwordChangeSubmit(e){
        e.preventDefault()
        if(password.length < 8){
            warningToast("Password must be 8 or more")
        }else if(password !== confirmPassword){
            warningToast("Password not matched")
        }else{

            const response = await serviceRequestObj.changePasswordUserOrAgent({password:password,confirm_password:confirmPassword},inputs.email)
            console.log(response)
            if(!response.response){
                successToast("Password Changed")
                setPassword("");
                setConfirmPassword("");
                setShowPasswordModal(false);
                
            }else{
                warningToast(response.response.data.message)
            }
        }



   } 

    return (
        <>
            <Container fluid>
            <Modal show={showPasswordModal} onHide={handleClose}>
                <Modal.Header closeButton>
                            <Modal.Title as="h5">Cambiare la password</Modal.Title>
                </Modal.Header>
                <Form className='g-3' onSubmit={passwordChangeSubmit}>
                <Modal.Body>

                    
                <div className=" mb-3" >
                                            <Form.Label htmlFor='password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.password}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='password' placeholder=''
                                                maxLength="30"
                                                value={password}
                                                onChange={(e)=>setPassword(e.target.value)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                </div>
                <div className=" mb-3" >
                                            <Form.Label htmlFor='confirm_password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.confirmPassword}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='confirm_password' placeholder=''
                                                maxLength="30"
                                                value={confirmPassword}
                                                onChange={(e)=>setConfirmPassword(e.target.value)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                </div>
                
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancellare</Button>
                    <Button variant="primary" type="submit" >Salva Modifiche</ Button>
                </Modal.Footer>
                </Form>
            </Modal>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={{ pathname: "/agent", state: {}}}> {AgentString.title} </Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page">{is_new_product ? AgentString.addAgent : (config.is_admin? AgentString.editAgent : AgentString.viewAgent) }</li>
                                    </ol>
                                </nav>
                            </div>
                            <Link to={{ pathname: "/agent", state: {}}} className="btn btn-primary btn-sm d-flex align-items-center justify-content-between ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="ml-2">{PublicStrings.back}</span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg="12" className="mb-3 d-flex justify-content-between">
                        <h4 className="font-weight-bold d-flex align-items-center">{is_new_product ? AgentString.addAgent : (config.is_admin? AgentString.editAgent : AgentString.viewAgent)}</h4>
                    </Col>
                    <Col lg="12">
                        <Card>
                            <Card.Body>
                                {loading && is_new_product === false ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                                        <ReactLoading
                                            type={"spin"}
                                            color={"#007bff"}
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                <Form className=" g-3" onSubmit={is_new_product ? submitCreateProduct : submitSaveProduct} ref={form}>
                                    <div className='row'>

                                        <Form.Control type='text' name='id' defaultValue={product_id} hidden />

                                        <div className="col-md-6 mb-3" key="1">
                                            <Form.Label htmlFor='name' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.name}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='name' placeholder=''
                                                maxLength="30"
                                                value={inputs["name"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" key="2">
                                            <Form.Label htmlFor='surname' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.surname}</Form.Label>
                                            <Form.Control type='surname' className="form-control" name='surname' placeholder=''
                                                maxLength="30"
                                                value={inputs["surname"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" key="3">
                                            <Form.Label htmlFor='email' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.email}</Form.Label>
                                            <Form.Control type='email' className="form-control" name='email' placeholder=''
                                                maxLength="30"
                                                value={inputs["email"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>

                                        {!is_new_product && (
                                            <>
                                                <div className="col-md-4 mb-3">
                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">Last Activity</Form.Label>
                                                    <Form.Control type='text' className="form-control" value={inputs["last_activity"] || '-'} disabled />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">Last Login</Form.Label>
                                                    <Form.Control type='text' className="form-control" value={inputs["last_login"] || '-'} disabled />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">Status</Form.Label>
                                                    <div>
                                                        {inputs.is_online ? (
                                                            <span className="badge bg-success">Online</span>
                                                        ) : (
                                                            <span className="badge bg-secondary">Offline</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <div className="col-md-6 mb-3">
                                            <Form.Label htmlFor='role' className="form-label font-weight-bold text-muted text-uppercase">Ruolo</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                className="form-control" 
                                                name='role'
                                                value={getCurrentRole()}
                                                onChange={handleRoleChange}
                                                disabled={isRoleFieldDisabled()}
                                                required
                                            >
                                                {getAvailableRoleOptions().map((option, index) => (
                                                    <option key={index} value={option.value}>{option.label}</option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                        
                                        {/* Conditional Agency Field - Single or Multiple Select */}
                                        <div className="col-md-12 mb-3" key="4">
                                            <Form.Group>
                                                <Form.Label htmlFor='agency' className="form-label font-weight-bold text-muted text-uppercase">
                                                    {isMultipleAgencySelect() ? 'Agenzie Gestite' : AgentString.agency}
                                                </Form.Label>
                                                
                                                {isMultipleAgencySelect() ? (
                                                    // Multiple select for non-boss roles with tag display
                                                    <>
                                                        <Form.Control 
                                                            as="select" 
                                                            className="mb-3" 
                                                            name='managed_agencies' 
                                                            onChange={handleMultipleAgencyChange}
                                                            disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                                            value="0"
                                                        >
                                                            <option value="0">Seleziona un'agenzia da aggiungere...</option>
                                                            {
                                                                getFilteredAgencies()
                                                                    .filter(e => !inputs.managed_agencies.includes(e.id.toString()) && !inputs.managed_agencies.includes(e.id))
                                                                    .map((e, index) =>
                                                                        <option key={index} value={e.id}>{e.name}</option>
                                                                    )
                                                            }
                                                        </Form.Control>

                                                        {/* Display selected agencies as tags */}
                                                        {inputs.managed_agencies.length > 0 && (
                                                            <div className="d-flex flex-wrap gap-2 mt-2" style={{ gap: '8px' }}>
                                                                {inputs.managed_agencies.map((agencyId, index) => (
                                                                    <span 
                                                                        key={index} 
                                                                        className="badge bg-primary d-flex align-items-center"
                                                                        style={{ 
                                                                            fontSize: '14px', 
                                                                            padding: '8px 12px',
                                                                            marginRight: '8px',
                                                                            marginBottom: '8px'
                                                                        }}
                                                                    >
                                                                        {getAgencyNameById(agencyId)}
                                                                        {config.is_admin && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn-close btn-close-white ms-2"
                                                                                style={{ 
                                                                                    fontSize: '10px',
                                                                                    marginLeft: '8px',
                                                                                    cursor: 'pointer',
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    color: 'white',
                                                                                    fontWeight: 'bold',
                                                                                    padding: '0'
                                                                                }}
                                                                                onClick={() => removeAgency(agencyId)}
                                                                                aria-label="Remove"
                                                                            >
                                                                                <svg 
                                                                                    xmlns="http://www.w3.org/2000/svg" 
                                                                                    width="16" 
                                                                                    height="16" 
                                                                                    fill="currentColor" 
                                                                                    viewBox="0 0 16 16"
                                                                                >
                                                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                                                </svg>
                                                                            </button>
                                                                        )}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}
                                                        
                                                        <Form.Text className="text-muted">
                                                            Seleziona le agenzie dal menu a discesa in alto. Le agenzie selezionate appariranno come tag.
                                                        </Form.Text>
                                                    </>
                                                ) : (
                                                    <Form.Control 
                                                        as="select" 
                                                        className="mb-3" 
                                                        name='agency' 
                                                        value={is_new_product ? (inputs['agency'] === null ? "0" : inputs['agency']) : (inputs['agency'] === null ? "0" : inputs['agency'])} 
                                                        onChange={handleChange}
                                                        disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager || !(inputs.is_agent || inputs.is_agency_boss)}
                                                    >
                                                        {
                                                            is_new_product || inputs['agency'] === null ?
                                                            <option value="0">Seleziona Agenzia</option> : <></>
                                                        }
                                                        {
                                                            getFilteredAgencies().length > 0 ?
                                                            getFilteredAgencies().map((e, index) =>
                                                                <option key={index} value={e.id}>{e.name}</option>
                                                            ) : <></>
                                                        }
                                                    </Form.Control>
                                                )}
                                            </Form.Group>
                                        </div>
                                        {
                                            is_new_product ?
                                            <>
                                        <div className="col-md-6 mb-3" key="5">
                                            <Form.Label htmlFor='password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.password}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='password' placeholder=''
                                                maxLength="30"
                                                value={inputs["password"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3" key="6">
                                            <Form.Label htmlFor='confirm_password' className="form-label font-weight-bold text-muted text-uppercase">{AgentString.confirmPassword}</Form.Label>
                                            <Form.Control type='password' className="form-control" name='confirm_password' placeholder=''
                                                maxLength="30"
                                                value={inputs["confirm_password"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>
                                        </>: <></>
                                        }
                                        
                                        {/* Commission and Permissions Fields */}
                                        <div className="col-md-12 mb-3">
                                            <hr />
                                            <h5 className="mb-3 font-weight-bold">Commissioni e Permessi</h5>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='can_force_edit' className="form-label font-weight-bold text-muted text-uppercase">Può Forzare Modifica</Form.Label>
                                            <div>
                                                <Form.Check 
                                                    type="switch" 
                                                    name="can_force_edit" 
                                                    id="can_force_edit" 
                                                    checked={!!inputs.can_force_edit} 
                                                    onChange={(e) => setInputs(values => ({ ...values, can_force_edit: e.target.checked }))}
                                                    disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='min_commission' className="form-label font-weight-bold text-muted text-uppercase">Commissione Minima</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                name="min_commission" 
                                                value={inputs.min_commission || 0} 
                                                onChange={handleChange}
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='max_commission' className="form-label font-weight-bold text-muted text-uppercase">Commissione Massima</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                name="max_commission" 
                                                value={inputs.max_commission || 0} 
                                                onChange={handleChange}
                                                disabled={!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='target' className="form-label font-weight-bold text-muted text-uppercase">Target Mensile (€)</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                step="0.01" 
                                                className="form-control" 
                                                name="target" 
                                                value={inputs.target || 0} 
                                                onChange={handleChange}
                                                disabled={!config.is_admin}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <Form.Label htmlFor='services_allowed' className="form-label font-weight-bold text-muted text-uppercase">Servizi Abilitati</Form.Label>
                                            <div>
                                                <Form.Check
                                                    type="switch"
                                                    name="services_allowed"
                                                    id="services_allowed"
                                                    checked={!!inputs.services_allowed}
                                                    onChange={(e) => setInputs(values => ({ ...values, services_allowed: e.target.checked }))}
                                                    disabled={
                                                        !inputs.is_agent ||
                                                        (!config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager)
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    {   
                                        !config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager ?  <></> :
                                            (
                                                loading ? 
                                                <>
                                                    <Button type="button" disabled><ReactLoading
                                                        className="mx-auto"
                                                        type={"spin"}
                                                        color={"#fefefe"}
                                                        height={24}
                                                        width={24}
                                                        /></Button> 
                                                        </>
                                                : 
                                                <Button type="submit">{is_new_product ? PublicStrings.add : PublicStrings.save}</Button>
                                            )

                                    }
                                    {   
                                        is_new_product || !config.is_admin && !config.is_agency_boss && !config.is_agency_admin && !config.is_internal_backoffice_manager && !config.is_institute_backoffice_manager && is_new_product ?  <></> :
                                            (
                                                loading ? 
                                                <>
                                                    <Button type="button" className='mx-2'  disabled><ReactLoading
                                                        className="mx-auto"
                                                        type={"spin"}
                                                        color={"#fefefe"}
                                                        height={24}
                                                        width={24}
                                                        /></Button> 
                                                        </>
                                                : 
                                                <Button type="button" className='mx-2' onClick={()=>{setShowPasswordModal(true)}}>{PublicStrings.changePassword}</Button>
                                            )

                                    }

                                    


                                </Form>
                                )}
                            </Card.Body>
                        </Card>

                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default AgentAddOrView;